import styled from "@emotion/styled";
import React, { useEffect, useRef, useState } from "react";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import { useNavigate } from "react-router-dom";
import noDataFound from "../../../../components/assets/No data-rafiki 1.svg";
import { getRequest, patchRequest } from "../../../../components/axiosClient";
import { errorNotification } from "../../../../components/toast-notification/common-toast";
import {
  GET_TASKS,
  UPDATE_PROJECT_TASKS_INDEX,
  UPDATE_TASK,
} from "../../../../components/utils";
import TaskCard from "./TaskCard";
import Select from "react-select";
import deleteIcon from "../../../../components/assets/bin.svg";
import { Box, ClickAwayListener, Drawer, Popover } from "@mui/material";
import { SlOptions } from "react-icons/sl";
import AddTaskListRow from "./AddTaskListRow";
import secureLocalStorage from "react-secure-storage";
import CustomDrawer from "../../../../components/Drawer/CustomDrawer";
import DrawerTaskDetail from "../../../../components/Drawer/DrawerTaskDetail";
// import { Select, MenuItem } from '@mui/material'; // MUI for dropdown

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  overflow-x: auto; /* Enable horizontal scrolling */
  scroll-behavior: smooth; /* Smooth scroll */
`;

const TaskList = styled.div`
  min-height: 100px;
  display: flex;
  flex-direction: column;
  background: #f3f3f3;
  min-width: 365px;
  border-radius: 5px;
  padding: 15px 15px;
  margin-right: 25px;
  ${"" /* height : calc(100vh - 350px) !important; */}
  overflow-y: auto;
`;

const TaskColumnStyles = styled.div`
  display: flex;
  width: 100%;
`;

const drawerWidth = "70%";

const TaskListKanban = ({
  projectId,
  handleTaskComplete,
  taskList,
  deleteStatus,
  getTasks,
  handleOpenModal,
  columnTitles,
  setColumnTitles,
  handleAddNewTitle,
  handleTitleChange,
  assignToFilterOption,
  memberList,
  boardView,
}) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  // const [taskList, setTaskList] = useState([]);
  const [columns, setColumns] = useState({});
  const [newTitle, setNewTitle] = useState("");
  const [addingTaskToColumn, setAddingTaskToColumn] = useState(null);
  const [statusDeleteId, setStatusDeleteId] = useState(null);
  const containerRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [selectedTaskId, setSelectedTaskId] = useState(null);

  const handleDrawerOpen = (taskId, projectId) => {
    setOpen(true);
    setSelectedTaskId(taskId);
    // navigate(`/task-details/${id}`);
  };

  const handleDrawerClose = () => {
    if(open){
      setOpen(false);
      setSelectedTaskId(null);
      getTasks();
    }
  };

  const role_access =
    JSON.parse(secureLocalStorage.getItem("role_accesses")).find(
      (access) => access.module.name === "Projects"
    )?.access_type !== "Read";

  const handleAutoScroll = (clientX) => {
    const scrollAmount = 20; // Scroll speed
    const container = containerRef.current;

    if (!container) return;

    const { left, right } = container.getBoundingClientRect();

    if (clientX < left + 50) {
      // Scroll left when near the left edge
      container.scrollLeft -= scrollAmount;
    } else if (clientX > right - 50) {
      // Scroll right when near the right edge
      container.scrollLeft += scrollAmount;
    }
  };

  const onDragUpdate = (update) => {
    if (update?.draggableProps?.style) {
      const { clientX } = update.draggableProps.style;
      handleAutoScroll(clientX);
    }
  };
  useEffect(() => {
    getTaskList();
  }, [taskList, columnTitles]);

  console.log(taskList);

  useEffect(() => {
    const handleDrag = (event) => {
      handleAutoScroll(event); // Reference to the auto-scroll function
    };

    document.addEventListener("drag", handleDrag);

    // Cleanup the listener on component unmount
    return () => {
      document.removeEventListener("drag", handleDrag);
    };
  }, [handleAutoScroll]); // Include the handleAutoScroll function as a dependency

  const getTaskList = async () => {
    const columnsFromBackend = columnTitles?.reduce((acc, item) => {
      acc[item.index] = {
        title: item.title,
        id: item.id,
        items:
          taskList?.filter((task) => task?.task_status?.id === item?.id) || [],
      };
      return acc;
    }, {});
    setColumns(columnsFromBackend);
  };

  const updateTaskStatus = async (payload) => {
    setLoading(true);

    try {
      const res = await patchRequest(`${UPDATE_TASK}`, payload, navigate);
      if (res?.response && res?.response.data.success) {
        return true;
        // successNotification(res.response.data.message);
      } else {
        errorNotification(res?.errormessage);
      }
    } catch (error) {
      errorNotification(error);
    } finally {
      setLoading(false);
    }
  };

  const updateIndexOfTask = async (data) => {
    const payload = {
      project_id: projectId,
      tasks: data,
    };
    setLoading(true);
    try {
      const res = await patchRequest(
        `${UPDATE_PROJECT_TASKS_INDEX}`,
        payload,
        navigate
      );
      if (res?.response && res?.response.data.success) {
      } else {
        errorNotification(res?.errormessage);
      }
    } catch (error) {
      errorNotification(error);
    } finally {
      setLoading(false);
    }
  };

  const onDragEnd = async (result) => {
    if (!result.destination) return;

    const { source, destination } = result;
    if (source.droppableId !== destination.droppableId) {
      const sourceColumn = columns[source.droppableId];
      const destColumn = columns[destination.droppableId];
      const sourceItems = [...sourceColumn.items];
      const destItems = [...destColumn.items];
      const [removed] = sourceItems.splice(source.index, 1);
      destItems.splice(destination.index, 0, removed);
      setColumns({
        ...columns,
        [source.droppableId]: {
          ...sourceColumn,
          items: sourceItems,
        },
        [destination.droppableId]: {
          ...destColumn,
          items: destItems,
        },
      });
      const updatedColumnsData = {
        ...columns,
        [source.droppableId]: {
          ...sourceColumn,
          items: sourceItems,
        },
        [destination.droppableId]: {
          ...destColumn,
          items: destItems,
        },
      };

      const updatedTask = {
        task_id: removed.id.toString(),
        status_id: columnTitles?.filter(
          (task) => task?.title == columns[destination.droppableId].title
        )[0]?.id,
      };
      const res = await updateTaskStatus(updatedTask);
      if (res) {
        const transformedData = Object.keys(updatedColumnsData).map((key) => {
          const statusObj = updatedColumnsData[key];
          return {
            title: statusObj.title || statusObj.items[0]?.task_status?.title, // Use title or extract from items
            taskIds: statusObj.items.map((task) => task.id), // Create array of task IDs
          };
        });
        await updateIndexOfTask(transformedData);
        await getTasks();
      }
    } else {
      // Handle moving within the same column
      const column = columns[source.droppableId];
      const copiedItems = [...column.items];
      const [removed] = copiedItems.splice(source.index, 1);
      copiedItems.splice(destination.index, 0, removed);
      setColumns({
        ...columns,
        [source.droppableId]: {
          ...column,
          items: copiedItems,
        },
      });
      const updatedColumnsData = {
        ...columns,
        [source.droppableId]: {
          ...column,
          items: copiedItems,
        },
      };
      const transformedData = Object.keys(updatedColumnsData).map((key) => {
        const statusObj = updatedColumnsData[key];
        return {
          title: statusObj.title || statusObj.items[0]?.task_status?.title, // Use title or extract from items
          taskIds: statusObj.items.map((task) => task.id), // Create array of task IDs
        };
      });
      await updateIndexOfTask(transformedData);
      await getTasks();
    }
  };

  const handleTaskView = (id) => {
    // navigate(`/task-details/${id}`);
  };

  // Delete PopOver
  const [anchorPopOVer, setAnchorPopOVer] = useState(null);

  const handleClickPopOVer = (event) => {
    setAnchorPopOVer(event.currentTarget);
  };

  const handleClosePopOVer = () => {
    setAnchorPopOVer(null);
    setStatusDeleteId(null);
  };

  const openPopOverPopOVer = Boolean(anchorPopOVer);
  const PopOverIds = openPopOverPopOVer
    ? "simple-popover-add-delete"
    : undefined;

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
  };

  return (
    <div className="overflow-x-auto h-full">
      {columns === null || columns === undefined ? (
        <div className="no__transcation">
          <img src={noDataFound} alt={noDataFound} loading="lazy" />
        </div>
      ) : (
        <DragDropContext
          onDragEnd={onDragEnd}
          className="h-full"
          onDragUpdate={onDragUpdate}
        >
          <Container ref={containerRef} className="h-full scroll-container">
            <TaskColumnStyles className="h-full">
              {Object.entries(columns).map(([columnId, column], index) => {
                return (
                  <Droppable
                    className="h-full"
                    key={columnId}
                    droppableId={columnId}
                  >
                    {(provided) => (
                      <TaskList
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                      >
                        <div className="flex items-center justify-between mb-2">
                          <div
                            className={`${
                              column?.title === "In Progress"
                                ? "text-[#db763b] bg-[#eeb08c3d] "
                                : column?.title === "Completed"
                                ? "text-[#83BF6E] bg-[#83bf6e24] "
                                : column?.title === "To be verified"
                                ? "text-[#8E59FF] bg-[#8e59ff1a] "
                                : "text-[#6F767E] bg-[#6F767E24] "
                            }  w-[calc(100% - 35px)] overflow-x-auto rounded self-start ${
                              column.items.length === 0 ? "mb-3" : ""
                            }`}
                          >
                            <input
                              type="text"
                              placeholder="Enter title of task"
                              className={`focus:border border-[#cfcbcb] rounded-md px-2 py-1 bg-transparent`}
                              value={columnTitles[index]?.title}
                              style={{
                                fieldSizing: "content",
                                minWidth: "2em",
                                maxWidth: "100%",
                              }}
                              onChange={(e) => {
                                setColumnTitles([
                                  ...columnTitles.slice(0, index),
                                  {
                                    ...columnTitles[index],
                                    title: e.target.value,
                                  },
                                  ...columnTitles.slice(index + 1),
                                ]);
                              }}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  e.preventDefault();
                                  e.target.blur();
                                  handleTitleChange(columnTitles[index]);
                                }
                              }}
                              onBlur={() => {
                                handleTitleChange(columnTitles[index]);
                              }}
                              // readOnly={!role_access}
                            />
                          </div>
                          <div className="flex p-2 items-center">
                            <button
                              aria-describedby={PopOverIds}
                              variant="contained"
                              onClick={(e) => {
                                handleClickPopOVer(e);
                                setStatusDeleteId(column?.id);
                              }}
                              className="cursor-pointer"
                            >
                              <SlOptions />
                            </button>
                          </div>
                        </div>
                        {column.items.map((item, index) => {
                          return (
                            <TaskCard
                              key={item.id}
                              item={item}
                              index={index}
                              // onDoubleClick={(e) => {
                              //   if (window.getSelection().toString() === "") {
                              //     // handleTaskView(item.id, item?.project?.id);
                              //     handleDrawerOpen(item.id, item?.project?.id);
                              //   }
                              // }}
                              onDoubleClick={(e) => {
                                e.stopPropagation();
                                if (window.getSelection().toString() === "") {
                                  // handleTaskView(item.id, item?.project?.id);
                                  handleDrawerOpen(item.id, item?.project?.id);
                                }
                              }}
                              handleTaskComplete={handleTaskComplete}
                              getTaskList={getTasks}
                              assignToFilterOption={assignToFilterOption}
                            />
                          );
                        })}

                        {provided.placeholder}
                        {/* <div className="flex w-full hover:bg-[#dddddd] rounded-lg mt-2.5">
                                                    <button className="grow p-2" onClick={() => handleOpenModal(column?.id)}>
                                                        + Add Task
                                                    </button>
                                                </div> */}
                        {addingTaskToColumn === columnId ? (
                          <AddTaskListRow
                            projectId={projectId}
                            onCancel={() => setAddingTaskToColumn(null)}
                            getTasks={getTasks}
                            memberList={memberList}
                            columnTitles={columnTitles}
                            boardView={boardView}
                            columnId={column?.id}
                          />
                        ) : (
                          <>
                            {role_access && (
                              <div className="flex w-full hover:bg-[#dddddd] rounded-lg mt-2.5">
                                <button
                                  className="grow p-2"
                                  onClick={() =>
                                    setAddingTaskToColumn(columnId)
                                  }
                                >
                                  + Add Task
                                </button>
                              </div>
                            )}
                          </>
                        )}
                      </TaskList>
                    )}
                  </Droppable>
                );
              })}

              {
                <TaskList>
                  <div className="flex w-full hover:bg-[#dddddd] rounded-lg mt-2.5">
                    <input
                      type="text"
                      className={`focus:border-2 border-[#cfcbcb] w-full rounded-md px-2 py-2 `}
                      placeholder="+ Add Section"
                      value={newTitle}
                      onChange={(e) => {
                        setNewTitle(e.target.value);
                      }}
                      onKeyDown={async (e) => {
                        if (e.key === "Enter" && newTitle) {
                          await handleAddNewTitle(newTitle);
                          setNewTitle("");
                          await getTaskList();
                        }
                      }}
                      onBlur={async () => {
                        if (newTitle) {
                          await handleAddNewTitle(newTitle);
                          setNewTitle("");
                          await getTaskList();
                        }
                      }}
                      // readOnly={!role_access}
                    />
                  </div>
                </TaskList>
              }
            </TaskColumnStyles>
          </Container>
        </DragDropContext>
      )}

      <div>
        <Popover
          id={PopOverIds}
          open={openPopOverPopOVer}
          anchorEl={anchorPopOVer}
          onClose={handleClosePopOVer}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          PaperProps={{
            style: {
              borderRadius: "6px",
              marginTop: "8px",
              boxShadow:
                "0px 4px 6px -2px rgba(16, 24, 40, 0.08), 0px 12px 16px -4px rgba(0, 66, 86, 0.14)",
            },
          }}
        >
          <div className="w-[170px] min-w-[170px] py-2 bg-[#FFFFFF] shadow-[0_35px_60px_-15px_rgba(0,66,86,0.08)]">
            <div
              className="flex px-[14px] py-2 hover:bg-[#F8F8F8] cursor-pointer items-center"
              onClick={(e) => {
                handleClosePopOVer();
                deleteStatus(statusDeleteId);
              }}
            >
              <img
                src={deleteIcon}
                alt="delete"
                className="mr-[14px] h-4 w-4"
              />
              <p className="font-medium text-[#3C556B] text-[14px] align-middle">
                Delete
              </p>
            </div>
          </div>
        </Popover>
        <Box sx={{ display: "flex" }}>
          <ClickAwayListener onClickAway={handleDrawerClose}>
            <Drawer
              sx={{
                width: drawerWidth,
                flexShrink: 0,
                "& .MuiDrawer-paper": { width: drawerWidth },
              }}
              variant="persistent"
              anchor="right"
              open={open}
            >
              <DrawerTaskDetail
                onClose={handleDrawerClose}
                selectedTaskId={selectedTaskId}
              />
            </Drawer>
          </ClickAwayListener>
        </Box>
      </div>
    </div>
  );
};

export default TaskListKanban;
